import * as Colors from '../../constants/Colors';
import { SvgIconProps } from '../IconProps';
import { BaseSvgIcon } from '../BaseSvgIcon';

export type MeasureBoldIconProps = SvgIconProps & {
    color?: string;
};

export const MeasureBoldIcon = ({ color, ...props }: MeasureBoldIconProps) => (
    <BaseSvgIcon viewBox="0 0 25 24" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9269 3C12.9269 2.44772 12.4792 2 11.9269 2C11.3746 2 10.9269 2.44772 10.9269 3V4.12602C9.20167 4.57006 7.9269 6.13616 7.9269 8C7.9269 9.0396 8.32349 9.98656 8.97364 10.6979C8.97208 10.7028 8.97056 10.7077 8.96907 10.7127L5.96907 20.7127C5.81037 21.2416 6.11056 21.7991 6.63955 21.9578C7.16854 22.1165 7.72603 21.8163 7.88473 21.2873L9.57682 15.647C10.5467 15.9451 11.5674 16.0568 12.5842 15.9729C13.1608 15.9254 13.7282 15.8157 14.277 15.647L15.9691 21.2873C16.1278 21.8163 16.6853 22.1165 17.2142 21.9578C17.7432 21.7991 18.0434 21.2416 17.8847 20.7127L16.1157 14.8157C16.1778 14.7776 16.2395 14.7385 16.3006 14.6985C17.4142 13.9714 18.329 12.9781 18.9622 11.8086C19.5953 10.639 19.9269 9.32997 19.9269 8C19.9269 7.73478 19.8215 7.48043 19.634 7.29289C19.4465 7.10536 19.1921 7 18.9269 7H18.9176C18.3653 7 17.9176 7.44772 17.9176 8C17.9176 8.99593 17.6693 9.97615 17.1951 10.852C16.7809 11.6171 16.2058 12.2815 15.511 12.8003L14.8847 10.7127L14.8802 10.6979C15.5303 9.98656 15.9269 9.0396 15.9269 8C15.9269 6.13616 14.6521 4.57006 12.9269 4.12602V3ZM10.1542 13.7224C10.8844 13.9486 11.6532 14.0336 12.4191 13.9704C12.8554 13.9345 13.2846 13.8509 13.6996 13.7224L13.1278 11.8166C12.7488 11.9358 12.3453 12 11.9269 12C11.5085 12 11.105 11.9358 10.726 11.8166L10.1542 13.7224ZM11.9269 6C10.8223 6 9.9269 6.89543 9.9269 8C9.9269 9.10457 10.8223 10 11.9269 10C13.0315 10 13.9269 9.10457 13.9269 8C13.9269 6.89543 13.0315 6 11.9269 6Z"
            fill={color}
        />
    </BaseSvgIcon>
);

MeasureBoldIcon.defaultProps = {
    color: Colors.black,
    height: '24px',
    width: '24px',
};
